// extracted by mini-css-extract-plugin
export default {"label":"SpectatingLabel__label__xmRHK"};